import styled from 'styled-components';

const GustoPageLayout = styled.section`
  align-items: center;
  display: flex;
  height: 100vh;
  flex-direction: column;
  justify-content: center;
  width: 100%;
`;

export default GustoPageLayout;
